






























































import { Component, Vue, Watch } from 'vue-property-decorator'
import SectionTuileNav from '@/components/shared/SectionTuileAnimNav.vue'
import { ITuileNav } from '@/models/ui/ITuileNav'
import SectionInfosObj from '@/components/shared/SectionInfosObj.vue'
import { ADomicile,ADomicileAdulte } from '@/router/pages';
import { ConvertToTuileNav, getDefaultAloActivity } from '@/models/alo/AloActivity';
import { getImageUrl } from '@/utils/images';
import { toSubArray } from '@/utils/groupBy';


@Component({
  name:"DetailActivite",
  props:{
    slug:{
      type:String,
      default:""
    },
    activityId:{
      type:Number,      
      default:0
    }
  },  
  components: { SectionTuileNav,SectionInfosObj}
})
export default class DetailActivite extends Vue {

  private slug!:string
  private activityId!:number
  private loading = true  
  private acyId:number = 0
  
  get twoLine(){
    return this.activity.content.pctSubTitle.length != this.subTitleHtml.length
  }

  get subTitleHtml(){
    return this.activity.content.pctSubTitle.replace('\n','<br/>')
  }
  
  private get arianeItems(){
     return [
        {
          text: 'Accueil',
          disabled: false,
          to: {name:'Home'},    
          exact:true      
        },
        {
          text: this.activity.acyEnfant?'Activités enfants':'Activités adultes',
          disabled: false,
          to: {name:this.activity.acyEnfant?'Enfants':'Adultes'},
          exact:true
        },
        {
          text: this.activity.libelle,
          disabled: true          
        },
    ]
  }


  mounted(){
    console.log(this.$route)
  }

  @Watch('slug')
  onSlugChanged(){
    this.loadActivity()
  }

  get getImageUrl(){
    return getImageUrl
  }

  get imageSliderUrl() {
    return getImageUrl(this.activity.image,1920,700,"crop")
  }
  
  get aPartir(){
    return this.activity.acyAge == 0?"à partir de 6 mois":(this.activity.acyAge?`à partir de ${this.activity.acyAge} ans`:"");
  }

  get activity() {    
    return this.activityDic[this.acyId] ?? getDefaultAloActivity()
  }

  get otherActivity(){
    const acys = this.$store.myGetters.activityList.filter(a => a.acyEnfant == this.activity.acyEnfant && a.id != this.activity.id).map(a => ConvertToTuileNav(a))
    acys.push(this.activity.acyEnfant?ADomicile:ADomicileAdulte) 
    return acys
  }

  get activityDic(){
    return this.$store.myGetters.activityDic
  }

  get infosPlusCols() {
    return toSubArray(this.activity.configActivity.infosPlus,2)
  }
  

  loadActivity() {            
    this.loading = true    
    if(this.activityId > 0) {
      this.$store.myActions.ADM_ACTIVITY_DETAIL_ENSURE(this.activityId).then((activity)=>{
        this.acyId = activity.id
      })
      .finally(() => {      
        this.loading = false
      })    
    }
    else{
      this.$store.myActions.ADM_ACTIVITY_DETAIL_REQUEST(this.slug).then((activity)=>{
        this.acyId = activity.id
      })
      .finally(() => {      
        this.loading = false
      })    
    }
  }

  

  created(){        
    this.$store.myActions.ADM_ACTIVITY_ENSURE()
    this.loadActivity()
  }
}
